<template>
    <img :src="src">
</template>

<script>
export default {
    name: "show",
    props: {
        src: {
            type: String,
            default: ""
        }
    }
}
</script>

<style>
img {
    width: 30px;
    fill: white !important;
}
</style>